import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DATE_FORMAT, LOCALIZATION_LOCALE } from '../models';
import { DateTimeUtils } from '../utils';

@Pipe({
  name: 'dateTimeFormatter',
  pure: false,
})
export class DateTimeFormatterPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: Date, ...args: any[]): any {
    if (!value) {
      return value;
    }

    const withoutSecond = !!args?.[0];

    let resultDate = this.getResult(
      value,
      this.translateService.currentLang as LOCALIZATION_LOCALE,
      withoutSecond
    );

    this.translateService.onLangChange.subscribe(() => {
      resultDate = this.getResult(
        value,
        this.translateService.currentLang as LOCALIZATION_LOCALE,
        withoutSecond
      );
    });

    return resultDate;
  }

  private getResult(
    input: Date,
    currentLang: LOCALIZATION_LOCALE,
    withoutSecond: boolean
  ): string {
    const dateFormat = this.getDateFormat(currentLang);

    return `${DateTimeUtils.formatDateToString(
      input,
      dateFormat
    )} ${DateTimeUtils.formatTimeToString(input, withoutSecond)}`;
  }

  private getDateFormat(selectedLang: LOCALIZATION_LOCALE): DATE_FORMAT {
    switch (selectedLang) {
      case LOCALIZATION_LOCALE.VN:
        return DATE_FORMAT.DATE_FORMAT_VN;
      case LOCALIZATION_LOCALE.DE:
        return DATE_FORMAT.DATE_FORMAT_DE;
      case LOCALIZATION_LOCALE.US:
        return DATE_FORMAT.DATE_FORMAT_US;
      default:
        return DATE_FORMAT.DATE_FORMAT_BACKEND;
    }
  }
}
